import { cleanCamelHash } from 'utils/questionnaireUtils';

export default function validateQuestionnaireAnswers(vals, { questionnaire }) {
  const errors = {};
  questionnaire.sections.forEach(s => {
    s.questions.forEach(q => {
      const fieldName = `${cleanCamelHash(s.title)}__${cleanCamelHash(q.prompt)}`;
      if (
        q.required &&
        (!vals[fieldName] || (vals[fieldName] instanceof Array && vals[fieldName].length < 1))
      ) {
        errors[fieldName] = 'this field is required';
      }
    });
  });

  return errors;
}
